import { styled } from "@mui/material/styles";
import { TableContainer } from "@mui/material";
import { StylesConfig } from "react-select";
import { BulkDropdownOption, DropdownOption } from "../screens/ServiceAgreements/types";


export const StyledTableContainer = styled(TableContainer)({
  maxHeight: '60vh',
  backgroundColor: '#f8fafc',
  fontFamily: 'Poppins, sans-serif',
  overflowX: 'auto',
  '& .MuiTable-root': {
    fontFamily: 'Poppins, sans-serif',
    borderCollapse: 'separate',
    borderSpacing: '0 4px',
    minWidth: '1200px',
  },
  '& .MuiTableHead-root': {
    fontFamily: 'Poppins, sans-serif',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    '& .MuiTableCell-root': {
      borderBottom: '1px solid #e2e8f0',
      BorderRight: '1px solid #e2e8f0',
      // color: '#ffffff',
      fontWeight: 600,
      fontSize: '12px',
      padding: '12px 16px',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  },
  '& .MuiTableBody-root': {
    '& .MuiTableRow-root': {
      fontFamily: 'Poppins, sans-serif',
      backgroundColor: '#ffffff',
      '&:hover': {
        fontFamily: 'Poppins, sans-serif',
        backgroundColor: '#f1f5f9',
      },
    },
    '& .MuiTableCell-root': {
      fontFamily: 'Poppins, sans-serif',
      borderBottom: '1px solid #e2e8f0',
      BorderRight: '1px solid #e2e8f0',
      padding: '16px',
      color: '#334155',
      fontSize: '12px',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-root:last-child': {
      fontFamily: 'Poppins, sans-serif',
      borderRight: 'none',
    }
  },
  '@media (max-width: 768px)': {
    maxHeight: '50vh',
  }
});
export const customStyle: StylesConfig<DropdownOption, false> = {
  control: (provided) => ({
    ...provided,
    padding: 0,
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
    height: '28px',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
    cursor: 'pointer',
    color: '#0ea5e9',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '12px',
    cursor: 'pointer',
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
  }),
  menu: (provided) => ({
    ...provided,
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
    borderRadius: '4px',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '175px',
    overflowY: 'auto',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1050,
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  input: (provided) => ({
    ...provided,
  }),
};

export const customStyles: StylesConfig<BulkDropdownOption, false> = {
  control: (provided) => ({
    ...provided,
    padding: 0,
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
    height: '28px',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
    cursor: 'pointer',
    color: '#0ea5e9',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '12px',
    cursor: 'pointer',
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
  }),
  menu: (provided) => ({
    ...provided,
    minWidth: '200px',
    maxWidth: '320px',
    width: '100%',
    borderRadius: '4px',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '175px',
    overflowY: 'auto',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1050,
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  input: (provided) => ({
    ...provided,
  }),
};

export const customStylesEditRow: StylesConfig<DropdownOption, false> = {
  control: (provided) => ({
    ...provided,
    padding: 0,
    width: '250px',
    height: '28px',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
    cursor: 'pointer'
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '12px',
    cursor: 'pointer'
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '4px',
    width: '250px',
    cursor: 'pointer'
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '150px',
    overflowY: 'auto',
    cursor: 'pointer'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1050,
    cursor: 'pointer'
  }),
};